import type { SVGProps } from 'react';

const SvgPlatform = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="platform">
      <path d="M15.25 3.21v13.08h-3.53v1.5h3.53v8.15h1.5V3.21l2.74 2.73 1.06-1.06-4-4a.74.74 0 0 0-1.06 0l-4 4 1.06 1.06Z" />
      <path d="M19.89 12.72 22 10.58v5.71h-3.1v1.5H22v5.53h1.5V10.58l2.14 2.14 1.06-1.06-3.39-3.42a.74.74 0 0 0-1.06 0l-3.42 3.42ZM8.69 10.58v12.74h1.5V10.58l2.15 2.14 1.06-1.06L10 8.24a.74.74 0 0 0-1.06 0l-3.45 3.42 1.06 1.06Z" />
      <path d="M3.77 31.35h24.46A2.75 2.75 0 0 0 31 28.6V19a2.75 2.75 0 0 0-2.75-2.75h-2.93v1.5h2.91A1.26 1.26 0 0 1 29.48 19v9.6a1.25 1.25 0 0 1-1.25 1.25H3.77a1.25 1.25 0 0 1-1.25-1.25V19a1.26 1.26 0 0 1 1.25-1.25H6.7v-1.5H3.77A2.75 2.75 0 0 0 1 19v9.6a2.75 2.75 0 0 0 2.77 2.75" />
    </g>
  </svg>
);

export default SvgPlatform;
